module.exports = __webpack_public_path__ + "static/media/2.3f76e428.jpg";